import React from "react";
import { Link } from "gatsby";
import Img from "gatsby-image";
import v4 from "uuid";
import Measure from "react-measure";

const Nav = ({ headerNames, location, logo, hidden, onResizeNav }) => {
  const hideStyle =
    hidden === undefined ? "" : hidden ? "slideOutUp" : "slideInDown";
  return (
    <header
      className={
        hideStyle + " bg-white fixed p-2 z-20 w-screen animated faster lg:p-0"
      }
    >
      <Measure
        client
        onResize={contentRect => onResizeNav(contentRect.client.height)}
      >
        {({ measureRef }) => (
          <nav
            ref={measureRef}
            className="container mx-auto flex flex-wrap justify-center"
          >
            <Link to="/" className="m-4 lg:m-2 lg:mr-auto content-center">
              <Img
                fixed={logo}
                className="w-32 h-24 align-middle inline-block mr-2"
              />
            </Link>

            <ul className="list-reset flex flex-wrap justify-center content-center text-lg">
              {headerNames.map(headerName => {
                const linkSelectedClass =
                  headerName.slug === location.pathname
                    ? " border-bet-dark border-2 text-bet-dark"
                    : "";
                return (
                  <li key={v4()}>
                    <Link
                      className={
                        "hover:bg-grey-light text-black rounded text-center inline-block p-2 no-underline transition-fast transition-property-bg transition-timing-ease-in" +
                        linkSelectedClass
                      }
                      to={headerName.slug}
                    >
                      {headerName.title}
                    </Link>
                  </li>
                );
              })}
            </ul>
          </nav>
        )}
      </Measure>
    </header>
  );
};

export default Nav;
